import { LoggerParamsTransformer } from '@content-platform/web-angular-shared-util-logging';
import { Store, select } from '@ngrx/store';
import { authSelectors } from '@content-platform/web-angular-shared-util-auth';
import { userRoleListActions } from '../actions';
import { userRoleListSelectors } from '../selectors';
import { ApplicationApiConstants } from '../application-api-config';
import { switchMap, filter } from 'rxjs';
export class UserRolesLoggingTransformer extends LoggerParamsTransformer {
    initialize() {
        // Check if user role loading is enabled for this app based on app name blacklist
        if (!ApplicationApiConstants.shouldLoadUserRoles()) {
            // If disabled, just set empty roles and return early
            this.roles = [];
            return;
        }
        this.store = this.injector.get(Store);
        this.store
            .pipe(select(authSelectors.getUserId), filter((userId) => !!userId), switchMap((userId) => {
            this.store.dispatch(new userRoleListActions.LoadById(userId));
            return this.store.pipe(select(userRoleListSelectors.getActiveUserRoleNames));
        }))
            .subscribe((roleNames) => {
            this.roles = roleNames;
        });
    }
    getParams() {
        return {
            userRoles: this.roles
        };
    }
}
//# sourceMappingURL=user-roles-logging-transformer.js.map